import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';

import { HkdBooksAPI } from 'apis/hkdBooks';

export const TAX_ALERTS_QUERY_KEY = ['hkd-books', 'tax-alerts'];

export const useTaxAlertsQuery = (options = {}) => {
  const query = useQuery({
    queryKey: TAX_ALERTS_QUERY_KEY,
    queryFn: HkdBooksAPI.getTaxAlerts,
    ...options,
  });

  return {
    ...query,
    alerts: get(query.data, 'data', []),
    loading: query.isLoading,
  };
};

export const useS2bReportQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2b', params],
    queryFn: () => HkdBooksAPI.getS2bReport(params),
    retry: (failureCount, error) => {
      const status = error?.response?.status;

      if (status >= 400 && status < 500) return false;

      return failureCount < 3;
    },
    ...options,
  });

  return {
    ...query,
    rows: get(query.data, 'data', []),
    emptyReason: get(query.data, 'empty_reason', null),
    periodBefore: get(query.data, 'period_before', null),
    periodAfter: get(query.data, 'period_after', null),
    loading: query.isLoading,
  };
};

export const useS2aReportQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2a', params],
    queryFn: () => HkdBooksAPI.getS2aReport(params),
    retry: (failureCount, error) => {
      const status = error?.response?.status;

      if (status >= 400 && status < 500) return false;

      return failureCount < 3;
    },
    ...options,
  });

  return {
    ...query,
    rows: get(query.data, 'data', []),
    emptyReason: get(query.data, 'empty_reason', null),
    periodBefore: get(query.data, 'period_before', null),
    periodAfter: get(query.data, 'period_after', null),
    loading: query.isLoading,
  };
};

export const useS2eReportQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2e', params],
    queryFn: () => HkdBooksAPI.getS2eReport(params),
    ...options,
  });

  return {
    ...query,
    rows: get(query.data, 'data', []),
    warnings: get(query.data, 'warnings', []),
    loading: query.isLoading,
  };
};

export const useS2cReportQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2c', params],
    queryFn: () => HkdBooksAPI.getS2cReport(params),
    retry: (failureCount, error) => {
      const status = error?.response?.status;

      if (status >= 400 && status < 500) return false;

      return failureCount < 3;
    },
    ...options,
  });

  return {
    ...query,
    rows: get(query.data, 'data', []),
    emptyReason: get(query.data, 'empty_reason', null),
    loading: query.isLoading,
  };
};

export const useS2dListQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2d', 'list', params],
    queryFn: () => HkdBooksAPI.getS2dReport(params),
    enabled: !params.product,
    ...options,
  });

  return {
    ...query,
    rows: get(query.data, 'data', []),
    loading: query.isLoading,
  };
};

export const useS2dLedgerQuery = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 's2d', 'ledger', params],
    queryFn: () => HkdBooksAPI.getS2dReport(params),
    enabled: !!params.product,
    ...options,
  });

  return {
    ...query,
    opening: get(query.data, 'opening', null),
    results: get(query.data, 'results', []),
    closing: get(query.data, 'closing', null),
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
